import React, { Component } from 'react';
import MUIDataTable from 'mui-datatables';
import RolePermissionManagementService from '@services/RolePermissionManagementService';
import SurveyService from '@services/SurveyService';
import CSVGenerator from '@components/CSVGenerator';
import SupportAlert from '@components/SupportAlert';
import SpinnerModal from '@components/SpinnerModal';
import AddSurveyCycleDialog from '../../../components/SystemAdministration/AddSurveyCycleDialog';
import { CustomDialog } from 'react-st-modal';
import { Alert, Checkbox, Chip, FormControl, FormControlLabel, Grid, Paper, Stack, Switch, Table, TableHead, TableBody, TableCell, TableContainer, TableRow, Tooltip } from '@mui/material';
import {
    AddLink,
} from "@mui/icons-material";

import styles from './surveycycles.module.css';

class SurveyCycles extends Component {
    state = {
        loading: false,
        surveyCyclesLoading: false,
        allSurveyCycles: [],
        surveysUserId: null,
    }

    parseJwt(token) {
        const base64Payload = token.split('.')[1];
        const payload = atob(base64Payload);
        return JSON.parse(payload.toString());
    }

    async componentDidMount() {
        this.setState({ loading: true });

        let payload = this.parseJwt(localStorage.getItem('Bearer'));
        this.setState({ surveysUserId: payload.user_id });

        this.reloadAllSurveyCycles();

        this.setState({ loading: false });
    }

    async reloadAllSurveyCycles() {
        this.setState({ surveyCyclesLoading: true });
        try {
            const surveyCycles = await SurveyService.getAllSurveyCycles();
            surveyCycles.sort((a, b) => a.id > b.id ? -1 : 1).forEach(surveyCycle => {
                if (!this.state.allSurveyCycles.some(item => item.id === surveyCycle.id)) {
                    this.state.allSurveyCycles.push(surveyCycle);
                }
            });
        } catch (ex) {
            // console.log('Network error loading survey cycles');
        }
        this.setState({ surveyCyclesLoading: false });
    }

    async onAddSurveyCycle(evt, data) {
        this.setState({ loading: true });

        try {
            await (async () => {
                const surveyCycle = await SurveyService.createSurveyCycle(data);
                if (surveyCycle !== undefined && surveyCycle !== null) {
                    await this.reloadAllSurveyCycles();
                } else {
                    SupportAlert.displayAlert('Create unsuccesful!', 'We could not create the survey cycle at this moment, please review your parameters and try again.');
                }
            })([]);
        } catch (ex) {
            // console.log('Error saving survey cycle: ' + ex);
        } finally {
            this.setState({ loading: false });
        }

    }

    async handleSetSurveyCycleStatusActive(evt, surveyCycleId) {
        this.setState({ systemPermissionsLoading: true });

        try {
            let surveyCycleToActivate = this.state.allSurveyCycles.filter((surveyCycle) => surveyCycle.id === surveyCycleId)[0];
            surveyCycleToActivate.status = 'ACTIVE';

        
            let updatedSurveyCycleEnvelope = {
                actionById: this.state.surveysUserId,
                surveyCycle: surveyCycleToActivate
            };

            const finalResult = await (async () => {
                const result = await SurveyService.setSurveyCycleStatus(surveyCycleId, 'ACTIVE', this.state.surveysUserId);
                return result;
            })([]);
            
            await (async () => {
                if (finalResult.id !== surveyCycleId) {
                    return await SupportAlert.displayAlert('Survey Cycle not updated. ', 'Activate Survey Cycle - Failed');
                } else {
                    // update the state with surveyCycleToActivate
                    this.setState({ allSurveyCycles: [...this.state.allSurveyCycles.filter(surveyCycle => surveyCycle.id !== surveyCycleId), surveyCycleToActivate] });
                    await this.reloadAllSurveyCycles();
                }
            })([]);
        } catch (ex) {
            // console.log('Error updating survey cycle: ' + ex);
        } finally {
            this.setState({ systemPermissionsLoading: false });
        }

    }

    async handleAddSurveyCycleDialog(evt) {

        let title = 'Add Survey Cycle';

        await CustomDialog(
            <AddSurveyCycleDialog
                {...this.props}
                backButton={{ text: 'Cancel' }}
                nextButton={{ text: 'Save', onClick: (evt, data) => this.onAddSurveyCycle(evt, data) }}
                surveysUserId={this.state.surveysUserId}
            />,
            {
                className: styles.addResearcherDialog,
                title: title,
                showCloseIcon: false,
                isFocusLock: true,
                isCanClose: false, // setting this to false prevents the dialog from being closed when clicking away
            }
        );
    }

    surveyCyclesTable() {
        let tableTitle = 'All Survey Cycles'.toUpperCase();

        let surveyCyclesTableData = [];

        let surveyCyclesColumns = [
            { label: "ID", name: "id" },
            { label: "Name", name: "name" },
            { label: "From Year", name: "referenceFromYear" },
            { label: "To Year", name: "referenceToYear" },
            { label: "Description", name: "description" },
            { label: "Status", name: "status" },
            { label: "Actions", name: "actions" },
        ];

        if (this.state.allSurveyCycles !== undefined && this.state.allSurveyCycles !== null && this.state.allSurveyCycles.length >= 0) {

            this.state.allSurveyCycles.sort((a, b) => a.id > b.id ? -1 : 1).forEach((surveyCycle) => {
                let row = {
                    id: surveyCycle.id,
                    name: surveyCycle.name,
                    researcherName: surveyCycle.firstName + ' ' + surveyCycle.lastName,
                    referenceFromYear: surveyCycle.referenceFromYear,
                    referenceToYear: surveyCycle.referenceToYear,
                    description: surveyCycle.description,
                    status: surveyCycle.status,
                    actions: surveyCycle.status === 'INPLANNING'
                        ? < Chip
                            variant="outlined"
                            icon={null}
                            label="Set Active"
                            onClick={evt => {
                                (async () => {
                                    this.setState({ loading: true });
                                    await this.handleSetSurveyCycleStatusActive(evt, surveyCycle.id);
                                    this.setState({ loading: false });
                                })([]);
                            }}
                        />
                        : < Chip
                            variant="outlined"
                            icon={null}
                            label="Set Completed"
                            disabled={true}
                        />,
                }

                surveyCyclesTableData.push(row);

            });
        }

        let options = {
            padding: 'none',
            size: 'small',
            rowsPerPage: 5,
            rowsPerPageOptions: [5, 10, 25, 50],
            jumpToPage: true,
            selectableRowsHideCheckboxes: true,
            textLabels: {
                toolbar: {
                    downloadCsv: "Export to excel",
                }
            },
            onDownload: (buildHead, buildBody, columns, data) => {
                (async () => {
                    await CSVGenerator.exportTableToXLS({
                        fileName: tableTitle,
                        columnNames: columns.filter(column => column.display !== 'false').map(item => item.label),
                        fileData: data.map(row => {
                            row.data.shift();
                            return row.data;
                        })
                    })
                })([]);
                return false;
            },
        };

        return <div className={styles.flex_row_container}>
            <MUIDataTable
                title={<div className={styles.featuredItem}><h1 className={styles.featuredTitleHeader}>{tableTitle}</h1></div>}
                data={surveyCyclesTableData}
                columns={surveyCyclesColumns}
                options={options}
            />
        </div>

    }

    render() {

        if (this.state.loading === true || this.state.surveyCyclesLoading === true) {
            return <SpinnerModal settings={true} label={'Survey cycles loading ...'} />
        } else {
            return (
                <div className={styles.container_surveycycles} >
                    <div className={styles.container_surveycycles} >
                        <div className={styles.featuredItem}>
                            <span className={styles.featuredTitleHeader}><h2>{'Survey Cycles'}</h2></span>
                            <hr />
                            <Grid container item xs={15} >
                                <Chip
                                    variant="outlined"
                                    icon={<AddLink />}
                                    label="Add Survey Cycle"
                                    onClick={evt => {
                                        (async () => {
                                            this.setState({ loading: true });
                                            await this.handleAddSurveyCycleDialog(evt);
                                            this.setState({ loading: false });
                                        })([]);
                                    }} />
                            </Grid>
                        </div>
                        <div className={styles.featuredItem}>
                            <Grid container item xs={15} >
                                {this.surveyCyclesTable()}
                            </Grid>
                        </div>
                    </div>
                </div>
            )
        }
    }
}
export default SurveyCycles;